import * as React from "react";
import { Helmet } from "react-helmet";
import favicons from "url:../../favicon/*.png";
import { resolveAsset } from "../asset";

const Favicon: React.FC = () => {
  return (
    <Helmet>
      <link
        rel="apple-touch-icon"
        sizes="57x57"
        href={resolveAsset(favicons["apple-icon-57x57"])}
      />
      <link
        rel="apple-touch-icon"
        sizes="60x60"
        href={resolveAsset(favicons["apple-icon-60x60"])}
      />
      <link
        rel="apple-touch-icon"
        sizes="72x72"
        href={resolveAsset(favicons["apple-icon-72x72"])}
      />
      <link
        rel="apple-touch-icon"
        sizes="76x76"
        href={resolveAsset(favicons["apple-icon-76x76"])}
      />
      <link
        rel="apple-touch-icon"
        sizes="114x114"
        href={resolveAsset(favicons["apple-icon-114x114"])}
      />
      <link
        rel="apple-touch-icon"
        sizes="120x120"
        href={resolveAsset(favicons["apple-icon-120x120"])}
      />
      <link
        rel="apple-touch-icon"
        sizes="144x144"
        href={resolveAsset(favicons["apple-icon-144x144"])}
      />
      <link
        rel="apple-touch-icon"
        sizes="152x152"
        href={resolveAsset(favicons["apple-icon-152x152"])}
      />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href={resolveAsset(favicons["apple-icon-180x180"])}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="192x192"
        href={resolveAsset(favicons["android-icon-192x192"])}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href={resolveAsset(favicons["favicon-32x32"])}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="96x96"
        href={resolveAsset(favicons["favicon-96x96"])}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href={resolveAsset(favicons["favicon-16x16"])}
      />
      <meta name="msapplication-TileColor" content="#ffffff" />
      <meta name="msapplication-TileImage" content={resolveAsset(favicons["ms-icon-144x144"])} />
      <meta name="theme-color" content="#ffffff" />
    </Helmet>
  );
};

export default Favicon;
